export const userDummyData = [
  {
    userId: "EMP001",
    username: "sivaram",
    password: "password123",
    employeeId: "RC1001",
    salutation: "Mr",
    name: "Sivaram",
    lastName: "K",
    gender: "Male",
    dob: "1998-05-15",
    age: "27",
    bloodgroup: "O+",
    martialstatus: "Single",
    presentaddress: "Chennai, Tamil Nadu",
    permanentaddress: "Salem, Tamil Nadu",
    fathername: "Raman",
    mothername: "Lakshmi",
    mobilenumber: "9876543210",
    aadharnumber: "123456789012",
    pannumber: "ABCDE1234F",
    uannumber: "112233445566",
    personalmailid: "sivaram.personal@gmail.com",
    officialmailid: "sivaram@redcloud.com",
    location: "Chennai",
    emergency: "9876543211",
    reportingmanager: "Arun Kumar",
    designation: "Frontend Developer",
    role: "Employee",
    profileImage: "https://via.placeholder.com/150"
  },

  {
    userId: "EMP002",
    name: "priya",
    password: "password123",
    employeeId: "RC1002",
    salutation: "Ms",
    firstName: "Priya",
    lastName: "S",
    gender: "Female",
    dob: "1997-08-20",
    age: "28",
    bloodgroup: "A+",
    martialstatus: "Married",
    presentaddress: "Bangalore, Karnataka",
    permanentaddress: "Madurai, Tamil Nadu",
    fathername: "Suresh",
    mothername: "Meena",
    mobilenumber: "9123456789",
    aadharnumber: "234567890123",
    pannumber: "PQRSX6789L",
    uannumber: "223344556677",
    personalmailid: "priya.personal@gmail.com",
    officialmailid: "priya@redcloud.com",
    location: "Bangalore",
    emergency: "9123456790",
    reportingmanager: "Ramesh",
    designation: "HR Executive",
    role: "HR",
    profileImage: "https://via.placeholder.com/150"
  }
];
// DummyTimeSheet.js
export const timeSheetDummyData = [
  {
    userId: "EMP001",
    date: "2026-01-10",
    checkin: "09:30 AM",
    checkout: "06:15 PM",
    status: "Present",
    productionhour: "8.45 hrs",
    createdAt: "2026-01-10 09:30",
  },
  {
    userId: "EMP001",
    date: "2026-01-11",
    checkin: "09:45 AM",
    checkout: "06:00 PM",
    status: "Present",
    productionhour: "8.15 hrs",
    createdAt: "2026-01-11 09:45",
  },
  {
    userId: "EMP001",
    date: "2026-01-12",
    checkin: "--",
    checkout: "--",
    status: "Absent",
    productionhour: "0 hrs",
    createdAt: "2026-01-12 00:00",
  },
];
// PayrollDummyData.js
export const payrollDummyData = [
  {
    userId: "EMP001",
    month: "January 2026",
    pfnumber: "PF123456",
    uannumber: "112233445566",
    totaldays: 31,
    daysworked: 26,
    crosssalary: 45000,
    deductions: 3500,
    netpayable: 41500,
  },
  {
    userId: "EMP001",
    month: "February 2026",
    pfnumber: "PF123456",
    uannumber: "112233445566",
    totaldays: 28,
    daysworked: 24,
    crosssalary: 45000,
    deductions: 3000,
    netpayable: 42000,
  },
];
export const employeeTableData = [
  {
    id: "1",
    employeeid: "EMP001",
    name: "Sivaram",
    email: "siva@company.com",
    mobile: "9876543210",
    department: "Development",
    status: "Present",
  },
  {
    id: "2",
    employeeid: "EMP002",
    name: "Priya",
    email: "priya@company.com",
    mobile: "9123456789",
    department: "HR",
    status: "Absent",
  },
];

export const adminDummyData = [
  {
    id: "1",
    personal: {
      username: "siva123",
      password: "123456",
      employeeId: "EMP001",
      salutation: "Mr",
      firstName: "Sivaram",
      lastName: "K",
      gender: "Male",
      dob: "1998-06-15",
      age: "27",
      bloodgroup: "O+",
      martialstatus: "Single",
      presentaddress: "Chennai, Tamil Nadu",
      permanentaddress: "Chennai, Tamil Nadu",
      fathername: "Kumar",
      mothername: "Lakshmi",
      mobilenumber: "9876543210",
      aadharnumber: "123412341234",
      pannumber: "ABCDE1234F",
      uannumber: "100200300400",
      personalmailid: "siva@gmail.com",
      officialmailid: "siva@company.com",
      location: "Chennai",
      emergency: "9876543211",
      reportingmanager: "Manager A",
      designation: "Frontend Developer",
      role: "Employee",
      profileImage: "https://via.placeholder.com/150",
    },

    qualification: {
      sslcschool: "ABC High School",
      sslcyearpass: "2013",
      hscschoolname: "XYZ Higher Secondary School",
      hscyearpass: "2015",
      ugdegree: "B.E",
      ugstream: "Computer Science",
      ugyearpass: "2019",
      ugcgpa: "8.2",
      pgdegree: "M.E",
      pgstream: "Software Engineering",
      pgyearpass: "2021",
      pgcgpa: "8.5",
    },

    experience: [
      {
        overallexperience: "3 Years",
        previousorgjoining: "2019",
        previousorgemployement: "2 Years",
        previouscompanyname: "Tech Solutions Pvt Ltd",
        previousdesignation: "Junior Developer",
      },
    ],
  },

  {
    id: "2",
    personal: {
      username: "priya456",
      password: "123456",
      employeeId: "EMP002",
      salutation: "Ms",
      firstName: "Priya",
      lastName: "R",
      gender: "Female",
      dob: "1997-02-20",
      age: "28",
      bloodgroup: "A+",
      martialstatus: "Married",
      presentaddress: "Coimbatore, Tamil Nadu",
      permanentaddress: "Coimbatore, Tamil Nadu",
      fathername: "Raman",
      mothername: "Meena",
      mobilenumber: "9123456789",
      aadharnumber: "234523452345",
      pannumber: "PQRSX6789Z",
      uannumber: "200300400500",
      personalmailid: "priya@gmail.com",
      officialmailid: "priya@company.com",
      location: "Coimbatore",
      emergency: "9123456790",
      reportingmanager: "Manager B",
      designation: "HR Executive",
      role: "Admin",
      profileImage: "https://via.placeholder.com/150",
    },

    qualification: {
      sslcschool: "Sunrise School",
      sslcyearpass: "2012",
      hscschoolname: "Green Valley School",
      hscyearpass: "2014",
      ugdegree: "B.Com",
      ugstream: "Commerce",
      ugyearpass: "2017",
      ugcgpa: "7.9",
      pgdegree: "MBA",
      pgstream: "HR",
      pgyearpass: "2019",
      pgcgpa: "8.3",
    },

    experience: [
      {
        overallexperience: "4 Years",
        previousorgjoining: "2019",
        previousorgemployement: "3 Years",
        previouscompanyname: "HR Corp",
        previousdesignation: "HR Assistant",
      },
    ],
  },
];
// ==============================
// ADMIN DUMMY DATA
// ==============================

export const adminData = [
  {
    id: "ADM001",
    name: "Sivaram",
    email: "superadmin@redcloud.com",
    mobile: "9876543210",
    role: "Super Admin",
    status: "Active",
    createdDate: "2026-01-01",
  },
  {
    id: "ADM002",
    name: "Karthik",
    email: "admin1@redcloud.com",
    mobile: "9123456789",
    role: "Admin",
    status: "Active",
    createdDate: "2026-01-05",
  },
  {
    id: "ADM003",
    name: "Priya",
    email: "admin2@redcloud.com",
    mobile: "9012345678",
    role: "Admin",
    status: "Blocked",
    createdDate: "2026-01-10",
  },
  {
    id: "ADM004",
    name: "Ramesh",
    email: "finance@redcloud.com",
    mobile: "9345678123",
    role: "Admin",
    status: "Active",
    createdDate: "2026-01-12",
  },
  {
    id: "ADM005",
    name: "Meena",
    email: "hr@redcloud.com",
    mobile: "9567890123",
    role: "Admin",
    status: "Active",
    createdDate: "2026-01-15",
  },
];
